import { api } from './api-client';
export type { McpConnection } from '@logspot-platform/platform-types';
import type { McpConnection } from '@logspot-platform/platform-types';

type SuccessEnvelope<T> = { data: T };

export const McpConnectionsService = {
  list: async (): Promise<McpConnection[]> => {
    const result =
      await api.get<SuccessEnvelope<McpConnection[]>>('/mcp/connections');
    return result.data;
  },

  revoke: async (clientId: string): Promise<void> => {
    await api.delete(`/mcp/connections/${encodeURIComponent(clientId)}`);
  },
};
